import React from 'react';
import { Text } from '@balance-web/text';
import { SpotWave } from '@balance-web/illustration';
import { DeprecatedButton } from '@balance-web/button-deprecated';
import { Flex } from '@balance-web/flex';
import { Stack } from '@balance-web/stack';
import { Heading } from '@balance-web/heading';

type AppListEmptyStateProps = {
  onAddProductsToAccountClick: () => void;
};

export const AppListEmptyState = ({
  onAddProductsToAccountClick,
}: AppListEmptyStateProps) => {
  return (
    <Flex
      direction="column"
      alignItems="center"
      flexGrow={1}
      padding="xlarge"
      gap="xlarge"
    >
      <SpotWave />
      <Stack align="center" gap="small">
        <Heading level="5">No products were found</Heading>
        <Text align="center" color="muted">
          There are currently no Reckon products associated with your account
        </Text>
        <Stack paddingTop="large">
          <DeprecatedButton
            label="Add products to your account"
            weight="subtle"
            onClick={onAddProductsToAccountClick}
          />
        </Stack>
      </Stack>
    </Flex>
  );
};
